import React from "react";
import "../AboutUs.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { NavLink } from "react-router-dom";

import {
    FiChevronRight,
    FiHome,
    FiArrowRight,
} from "react-icons/fi";

const AboutUs = () => {

    return (

        <>
            <Header />

            {/* ======================================
                    PAGE HERO
            ======================================= */}

            <section className="about-page-hero">

                <div className="about-overlay"></div>

                <div className="container">

                    <div className="about-hero-content">

                        <span className="about-tag">
                            Company Profile
                        </span>

                        <h1>
                            About
                            <span> Kishancart Digital</span>
                        </h1>

                        <p>
                            Kishancart Digital (OPC) Private Limited is a
                            technology-driven company committed to empowering
                            startups, retailers, enterprises, and agricultural
                            businesses through innovative digital solutions.
                            We specialize in building secure e-commerce
                            platforms, business websites, mobile applications,
                            marketplace solutions, and custom software that
                            help organizations grow in the digital era.
                        </p>

                    </div>

                </div>

            </section>

            {/* ======================================
                    BREADCRUMB
            ======================================= */}

            <section className="breadcrumb-section">

                <div className="container">

                    <div className="breadcrumb">

                        <NavLink to="/">
                            <FiHome />
                            Home
                        </NavLink>

                        <FiChevronRight />

                        <span>Company</span>

                        <FiChevronRight />

                        <span className="active">
                            About Us
                        </span>

                    </div>

                </div>

            </section>

            {/* ======================================
                NEXT PART STARTS HERE
                Who We Are Section
            ======================================= */}

            {/* ======================================
                    WHO WE ARE
            ======================================= */}

            <section className="about-company">

                <div className="container">

                    <div className="about-company-grid">

                        {/* Left */}

                        <div className="about-company-content">

                            <span className="section-tag">
                                Who We Are
                            </span>

                            <h2>
                                Building Digital Solutions That
                                <span> Drive Business Growth</span>
                            </h2>

                            <p>
                                Kishancart Digital (OPC) Private Limited is a
                                technology company focused on helping startups,
                                retailers, wholesalers, enterprises, and
                                agricultural businesses embrace digital
                                transformation. We design and develop modern,
                                secure, and scalable software solutions that
                                simplify business operations and improve
                                customer experiences.
                            </p>

                            <p>
                                Our expertise spans e-commerce development,
                                multi-vendor marketplaces, retail management,
                                ERP, CRM, inventory management, mobile
                                applications, and custom web solutions. Every
                                solution is built with innovation, performance,
                                security, and long-term scalability in mind.
                            </p>

                            <p>
                                We believe technology should empower businesses
                                to operate smarter, serve customers better, and
                                achieve sustainable growth. Our dedicated team
                                works closely with every client to understand
                                their goals and deliver solutions that create
                                measurable business value.
                            </p>

                        </div>

                        {/* Right */}

                        <div className="about-highlights">

                            <div className="highlight-card">

                                <h3>Our Strengths</h3>

                                <p>
                                    We combine technical excellence, industry expertise, and innovative
                                    thinking to deliver scalable e-commerce platforms, enterprise software,
                                    and digital solutions that help businesses achieve sustainable growth.
                                </p>

                            </div>

                            <div className="highlight-card">

                                <h3>Our Approach</h3>

                                <p>
                                    Every project begins with understanding your business goals. We
                                    follow a collaborative, transparent, and agile development process
                                    to deliver solutions that create measurable business value.
                                </p>

                            </div>

                            <div className="highlight-card">

                                <h3>Our Commitment</h3>

                                <p>
                                    We are committed to quality, transparency,
                                    innovation, and long-term partnerships that
                                    help our clients succeed in the digital era.
                                </p>

                            </div>

                        </div>

                    </div>

                </div>

            </section>

            {/* ======================================
                    COMPANY PROFILE
            ======================================= */}

            <section className="company-profile">

                <div className="container">

                    <div className="section-heading">

                        <span className="section-tag">
                            Company Profile
                        </span>

                        <h2>
                            Company <span>Information</span>
                        </h2>

                        <p>
                            A quick overview of Kishancart Digital (OPC)
                            Private Limited and the business solutions we
                            provide.
                        </p>

                    </div>

                    <div className="profile-grid">

                        <div className="profile-card">
                            <h4>Company Name</h4>
                            <p>Kishancart Digital (OPC) Private Limited</p>
                        </div>

                        <div className="profile-card">
                            <h4>Business Type</h4>
                            <p>Information Technology & Software Development</p>
                        </div>

                        <div className="profile-card">
                            <h4>Industry</h4>
                            <p>E-Commerce, Retail & Digital Solutions</p>
                        </div>

                        <div className="profile-card">
                            <h4>Core Services</h4>
                            <p>
                                E-Commerce Development, Mobile Apps,
                                Marketplace Platforms & Custom Software
                            </p>
                        </div>

                        <div className="profile-card">
                            <h4>Business Model</h4>
                            <p>
                                Custom Software Development, Consulting &
                                Digital Transformation Services
                            </p>
                        </div>

                        <div className="profile-card">
                            <h4>Support</h4>
                            <p>
                                Technical Consultation, Maintenance &
                                Long-Term Business Support
                            </p>
                        </div>

                    </div>

                </div>

            </section>

            {/* ======================================
                NEXT PART STARTS HERE
                Expertise + Core Values
            ====================================== */}
            {/* ======================================
                    OUR EXPERTISE
            ======================================= */}

            <section className="about-expertise">

                <div className="container">

                    <div className="section-heading">

                        <span className="section-tag">
                            Our Expertise
                        </span>

                        <h2>
                            Delivering <span>Smart Digital Solutions</span>
                        </h2>

                        <p>
                            We help startups, retailers, enterprises, and
                            agricultural businesses accelerate their digital
                            transformation through innovative, scalable, and
                            secure technology solutions.
                        </p>

                    </div>

                    <div className="expertise-grid">

                        <div className="expertise-card">

                            <div className="expertise-icon">
                                💻
                            </div>

                            <h3>Custom Software Development</h3>

                            <p>
                                Tailor-made software solutions designed to
                                automate business processes and improve
                                operational efficiency.
                            </p>

                        </div>

                        <div className="expertise-card">

                            <div className="expertise-icon">
                                🛒
                            </div>

                            <h3>E-Commerce Development</h3>

                            <p>
                                High-performance online stores with secure
                                payment gateways, inventory management, and
                                seamless customer experiences.
                            </p>

                        </div>

                        <div className="expertise-card">

                            <div className="expertise-icon">
                                🏪
                            </div>

                            <h3>Marketplace Solutions</h3>

                            <p>
                                Build scalable multi-vendor marketplace
                                platforms with vendor management and order
                                processing capabilities.
                            </p>

                        </div>

                        <div className="expertise-card">

                            <div className="expertise-icon">
                                📱
                            </div>

                            <h3>Mobile Applications</h3>

                            <p>
                                Android and iOS applications that provide
                                engaging user experiences and business
                                functionality.
                            </p>

                        </div>

                        <div className="expertise-card">

                            <div className="expertise-icon">
                                📊
                            </div>

                            <h3>ERP & Business Automation</h3>

                            <p>
                                Smart ERP, CRM, inventory, and workflow
                                management solutions for efficient business
                                operations.
                            </p>

                        </div>

                        <div className="expertise-card">

                            <div className="expertise-icon">
                                🌐
                            </div>

                            <h3>Digital Transformation</h3>

                            <p>
                                Helping businesses embrace modern technology,
                                cloud solutions, automation, and digital
                                innovation.
                            </p>

                        </div>

                    </div>

                </div>

            </section>

            {/* ======================================
                    CORE VALUES
            ======================================= */}

            <section className="core-values">

                <div className="container">

                    <div className="section-heading">

                        <span className="section-tag">
                            Our Core Values
                        </span>

                        <h2>
                            Values That <span>Define Us</span>
                        </h2>

                        <p>
                            Our values guide every project we undertake and
                            every partnership we build, ensuring exceptional
                            quality and long-term success.
                        </p>

                    </div>

                    <div className="values-grid">

                        <div className="value-card">

                            <div className="value-icon">
                                💡
                            </div>

                            <h3>Innovation</h3>

                            <p>
                                We continuously adopt modern technologies and
                                creative ideas to build future-ready digital
                                solutions.
                            </p>

                        </div>

                        <div className="value-card">

                            <div className="value-icon">
                                🤝
                            </div>

                            <h3>Integrity</h3>

                            <p>
                                We believe in transparency, honesty, and
                                building trustworthy relationships with every
                                client.
                            </p>

                        </div>

                        <div className="value-card">

                            <div className="value-icon">
                                ⭐
                            </div>

                            <h3>Quality Excellence</h3>

                            <p>
                                Every project is developed with high standards
                                of quality, performance, and reliability.
                            </p>

                        </div>

                        <div className="value-card">

                            <div className="value-icon">
                                🚀
                            </div>

                            <h3>Customer Success</h3>

                            <p>
                                Your business growth is our priority. We focus
                                on delivering solutions that create measurable
                                value and long-term success.
                            </p>

                        </div>

                    </div>

                </div>

            </section>

            {/* ======================================
                NEXT PART STARTS HERE
                Business Information + CTA + Footer
            ====================================== */}

            {/* ======================================
                    BUSINESS INFORMATION
            ======================================= */}

            <section className="business-information">

                <div className="container">

                    <div className="section-heading">

                        <span className="section-tag">
                            Business Information
                        </span>

                        <h2>
                            Company <span>Details</span>
                        </h2>

                        <p>
                            Here is some important information about
                            Kishancart Digital (OPC) Private Limited.
                        </p>

                    </div>

                    <div className="business-grid">

                        <div className="business-card">
                            <h4>Company Name</h4>
                            <p>Kishancart Digital (OPC) Private Limited</p>
                        </div>

                        <div className="business-card">
                            <h4>Business Category</h4>
                            <p>
                                Information Technology, Software Development &
                                E-Commerce Solutions
                            </p>
                        </div>

                        <div className="business-card">
                            <h4>Registered Office</h4>
                            <p>
                                603 A6, Md Complex, Lalganesh Lokhra Road, Odalbakra, Kamrup, Gmc, Assam, India - 781034
                            </p>
                        </div>

                        <div className="business-card">
                            <h4>Email Address</h4>
                            <p>contact@opckishancart-digital.in</p>
                        </div>

                        <div className="business-card">
                            <h4>Contact Number</h4>
                            <p>+913617701489</p>
                        </div>

                        <div className="business-card">
                            <h4>Business Hours</h4>
                            <p>
                                Monday – Saturday<br />
                                09:00 AM – 06:30 PM
                            </p>
                        </div>

                        <div className="business-card">
                            <h4>Website</h4>
                            <p>https://opckishancart-digital.in/</p>
                        </div>

                        <div className="business-card">
                            <h4>Support Services</h4>
                            <p>
                                Technical Support, Business Consultation,
                                Maintenance & Upgrades
                            </p>
                        </div>

                    </div>

                </div>

            </section>

            {/* ======================================
                    CALL TO ACTION
            ======================================= */}

            {/* <section className="about-cta">

                <div className="container">

                    <div className="cta-box">

                        <span className="section-tag">
                            Let's Build Something Amazing
                        </span>

                        <h2>
                            Ready to Transform Your Business?
                        </h2>

                        <p>
                            Whether you're launching a startup, building an
                            e-commerce platform, creating a marketplace,
                            developing a mobile app, or automating business
                            operations, Kishancart Digital is here to help.
                            Let's work together to create secure, scalable,
                            and innovative digital solutions that drive your
                            business forward.
                        </p>

                        <div className="cta-buttons">

                            <NavLink
                                to="/contact"
                                className="primary-btn"
                            >
                                Contact Us
                                <FiArrowRight />
                            </NavLink>

                            <NavLink
                                to="/services"
                                className="secondary-btn"
                            >
                                Explore Services
                            </NavLink>

                        </div>

                    </div>

                </div>

            </section> */}

            <Footer />

        </>

    );

};

export default AboutUs;